import React, { forwardRef, Ref, useState } from 'react';
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { TextField } from 'new/elements/TextField';

export const PasswordTextField = forwardRef<HTMLDivElement, TextFieldProps>(
  (props: TextFieldProps, ref: Ref<HTMLDivElement>) => {
    const [showPassword, setShowPassword] = useState(false);

    const toggleVisibility = () => {
      setShowPassword((show) => !show);
    };

    return (
      <TextField
        ref={ref}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={toggleVisibility}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...props}
      />
    );
  },
);
